import { Text, useAlert, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React, { useCallback, useEffect } from 'react';

import { useMasterStateActions } from '../../../store/master/actions';
import { useMismatchingPartner } from '../hooks/useMismatchingPartner';

export const CockpitSectionBlockingMismatchedPartner: React.FC = () => {
  const isMismatchingPartner = useMismatchingPartner();
  const { alert } = useAlert();
  const { clearSelectedAdvisor } = useMasterStateActions();
  const handleCloseAlert = useCallback(() => {
    clearSelectedAdvisor();
  }, [clearSelectedAdvisor]);

  useEffect(() => {
    if (isMismatchingPartner) {
      alert(
        {
          title: 'Esta tela não está disponível no momento',
          icon: 'Warning',
          iconColor: 'feedback.attention.default',
          description: (
            <VStack space={Spacing['stack.quarck']}>
              <Text>
                Identificamos que a filial selecionada é diferente da filial inicial cadastrada.
              </Text>
              <Text>Você será redirecionado automaticamente para a sua filial inicial</Text>
            </VStack>
          ),
          actionText: 'Continuar',
        },
        handleCloseAlert
      );
    }
  }, [alert, isMismatchingPartner, handleCloseAlert]);

  return null;
};
